module.exports = __webpack_public_path__ + "img/purpose_5.06529153.png";